"use client";

import { size, theme } from "@/config/theme";
import { SCContainerContent } from "@/utils/styledComponents";
import { useTranslations } from "next-intl";
import styled from "styled-components";
import imageBeginner from "/public/media/images/image-swimmingprogramme-beginnerclass.png";
import imageIntermediate from "/public/media/images/image-swimmingprogramme-intermediateclass.png";
import imageCert from "/public/media/images/image-swimmingprogramme-cert.png";
import Image from "next/image";
import { breakpoints } from "@/utils/breakpoint";
import iconArrowRightBlue from "/public/media/images/icon-arrowright-blue.png";
import iconArrowRightPurple from "/public/media/images/icon-arrowright-purple.png";
import iconPhase1 from "/public/media/images/icon-phase1.png";
import iconPhase2 from "/public/media/images/icon-phase2.png";
const SwimmingProgramme = () => {
    const t = useTranslations("SwimmingProgramme");
    return (
        <SCSwimmingProgramme>
            <SCSwimmingProgrammeContent>
                <div className="text-container">
                    <h2 className="text-largexlarge">{t("title-text")}</h2>
                    <div className="text-medium">{t("description-text")}</div>
                </div>
                <div className="class-container beginner">
                    <div className="text-container">
                        {/* <div className="tag">{t("tag-text1")}</div> */}
                        <div className="tag">
                            <Image
                                src={iconPhase1}
                                alt={"Phase 1"}
                                width={98}
                                height={42}
                            />
                        </div>
                        <h3 className="text-largexlarge">
                            {t("beginnerClass-title-text")}
                        </h3>
                        <div className="text-medium">
                            {t("beginnerClass-description-text")}
                        </div>
                        <div className="text-container-arrow">
                            <div>
                                <Image src={iconArrowRightBlue} alt="" />{" "}
                                {t("beginnerClass-pointer-text1")}
                            </div>
                            <div>
                                <Image src={iconArrowRightBlue} alt="" />{" "}
                                {t("beginnerClass-pointer-text2")}
                            </div>
                            <div>
                                <Image src={iconArrowRightBlue} alt="" />{" "}
                                {t("beginnerClass-pointer-text3")}
                            </div>
                            <div>
                                <Image src={iconArrowRightBlue} alt="" />{" "}
                                {t("beginnerClass-pointer-text4")}
                            </div>
                        </div>
                    </div>
                    <div className="image-container">
                        <Image
                            src={imageBeginner}
                            alt="children participating in a swimming class for kids"
                            loading="lazy"
                            sizes="(max-width: 768px) 60vw, 400px"
                        />
                    </div>
                </div>
                <div className="class-container intermediate">
                    <div className="image-container">
                        <Image
                            src={imageIntermediate}
                            alt="coach teaching a kid's swimming lesson in Singapore"
                            loading="lazy"
                            sizes="(max-width: 768px) 60vw, 400px"
                        />
                    </div>
                    <div className="text-container">
                        {/* <div className="tag">{t("tag-text2")}</div> */}
                        <div className="tag">
                            <Image
                                src={iconPhase2}
                                alt={"Phase 2"}
                                width={98}
                                height={42}
                            />
                        </div>
                        <h3 className="text-largexlarge">
                            {t("intermediateClass-title-text")}
                        </h3>
                        <div className="text-medium">
                            {t("intermediateClass-description-text")}
                        </div>
                        <div className="text-container-arrow">
                            <div>
                                <Image src={iconArrowRightPurple} alt="" />{" "}
                                {t("intermediateClass-pointer-text1")}
                            </div>
                            <div>
                                <Image src={iconArrowRightPurple} alt="" />{" "}
                                {t("intermediateClass-pointer-text2")}
                            </div>
                        </div>
                        <div className="image-container">
                            <Image
                                src={imageCert}
                                alt=" SwimSafer Stage 1 Award certificate"
                            />
                        </div>
                    </div>
                </div>
            </SCSwimmingProgrammeContent>
        </SCSwimmingProgramme>
    );
};

export default SwimmingProgramme;

const SCSwimmingProgramme = styled.div`
    background-image: url("/media/images/background-swimmingprogramme-pool.webp");
    background-position: 50% 50%;
    background-size: cover;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: ${theme["spacing-lxl"]} 0;
`;

const SCSwimmingProgrammeContent = styled(SCContainerContent)`
    display: flex;
    flex-direction: column;
    overflow: none;

    .text-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: ${theme["spacing-l"]};

        .text-largexlarge {
            font-size: ${theme["fontsize-lxl"]};
            font-weight: 500;
            margin-bottom: ${theme["spacing-m"]};
        }

        .text-medium {
            font-size: ${theme["fontsize-m"]};
            color: ${theme["color-grey"]};
        }
    }

    .class-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-bottom: ${theme["spacing-l"]};

        // Mobile view
        ${breakpoints(
            "flex-direction",
            "",
            [{ [size.px.sxs]: "column" }],
            "max-width"
        )};

        &:last-child {
            margin-bottom: 0;
        }

        &.beginner {
            // Mobile view
            ${breakpoints(
                "flex-direction",
                "",
                [{ [size.px.sxs]: "column-reverse" }],
                "max-width"
            )};
            ${breakpoints(
                "margin-bottom",
                "",
                [{ [size.px.sxs]: "50px" }],
                "max-width"
            )};
        }

        > div {
            align-items: normal;
            // width: 400px;
            width: 40%;
        }

        .image-container {
            display: flex;
            align-items: center;
            justify-content: center;

            // Mobile view
            ${breakpoints(
                "width",
                "",
                [{ [size.px.sxs]: "100%" }],
                "max-width"
            )};

            img {
                width: 400px;
                min-width: 300px;
                height: auto;

                // Mobile view
                ${breakpoints(
                    "width",
                    "",
                    [{ [size.px.sxs]: "60%" }],
                    "max-width"
                )};
            }
        }

        .text-container {
            margin-bottom: 0;
            padding: ${theme["spacing-ml"]};

            // Mobile view
            ${breakpoints(
                "width",
                "",
                [{ [size.px.sxs]: "100%" }],
                "max-width"
            )};
            ${breakpoints(
                "padding-top",
                "",
                [{ [size.px.sxs]: "0" }],
                "max-width"
            )};

            .tag {
                // font-size: ${theme["fontsize-xs"]};
                // background-color: ${theme["color-dark-blue"]};
                // color: ${theme["color-white"]};
                // padding: ${theme["spacing-s"]}
                //     ${theme["spacing-sm"]};
                // width: fit-content;
                // border-radius: 15px;
                margin-bottom: ${theme["spacing-m"]};

                img {
                    width: auto;
                    height: auto;
                }
            }

            .text-largexlarge {
                margin-bottom: ${theme["spacing-m"]};
            }

            .text-medium {
                color: ${theme["color-black"]};
                margin-bottom: ${theme["spacing-l"]};
            }

            .text-container-arrow {
                > div {
                    margin-bottom: ${theme["spacing-sm"]};
                }
            }
        }

        &.intermediate .text-container .image-container img {
            width: 100%;
        }

        &.intermediate {
            color: ${theme["color-white"]};

            .text-medium {
                color: ${theme["color-white"]};
            }
        }
    }
`;
